













































import Component, { mixins } from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { AgingFilterFormsMixin } from '@/views/app/management/collections/components/GlobalAging/AgingFilterFormsMixin'
import { Debounce } from 'vue-debounce-decorator'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { IResident } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

@Component({
  components: { LoaderWrapper, Checkbox, ScrollView, SearchInput },
  props: {
    facilities: {
      type: Array
    }
  }
})
export default class ResidentFilterForm extends mixins(AgingFilterFormsMixin) {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  localOptions: any = {}

  get selectedResidents () {
    return this.filtersMap['residents']
  }

  @Debounce(800)
  async fetchData () {
    if (!this.searchValue) {
      return
    }

    try {
      const filters = {
        facilities: this.$props.facilities,
        residentName: this.searchValue.trim(),
        limit: 1000,
        skip: 0
      }
      this.isLoading = true

      const res = await this.residentModuleInstance.getAndReturnResidentsFilteredList(filters)
      const optionMap: any = {}

      if (res && res.length) {
        res.forEach((resident: IResident) => {
          optionMap[resident.id] = {
            value: resident.id,
            label: `${resident.firstName ? resident.firstName : ''} ${resident.lastName ? resident.lastName : ''}`
          }
        })
      }
      this.localOptions = optionMap
    } finally {
      this.isLoading = false
      if (this.focusEl) {
        setTimeout(() => this.focusEl.focus(), 50)
      }
    }
  }
}
